export const SSO_TOKEN_NAME = "dely-jwt";
